import { put, takeLeading, call, takeEvery } from "redux-saga/effects";
import request from "utils/api";
import Helper from "utils/helpers";
import _pick from "lodash/pick";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import { safe } from "providers/GeneralProvider/saga";
import {
  getAllConsulateRequest,
  getAllConsulateSuccess,
  stopLoading,
  createConsulateRequest,
  createConsulateSuccess,
  updateActiveConsulateRequest,
  updateActiveConsulateSuccess,
  deleteConsulateRequest,
  deleteConsulateSuccess,
  getConsulateDetailRequest,
  getConsulateDetailSuccess,
  updateConsulateRequest,
  updateConsulateSuccess,
  updateOrderConsulateRequest,
  updateOrderConsulateSuccess,
} from "providers/ConsulateProvider/slice";

function* getAllConsulate(action) {
  const params = _pick(action.payload, [
    "page",
    "limit",
    "keyword",
    "sortTitle",
    "isActive",
    "sort",
  ]);
  if (!_isEmpty(params.keyword)) {
    params.keyword =
      Helper.sortStringWithoutSpecialChars(params.keyword) || undefined;
  }
  const { data } = yield call(
    request,
    "api/admin/consulate/category/get-all",
    params,
    { method: "GET" }
  );
  yield put(getAllConsulateSuccess(data));
}

function* createConsulate(action) {
  const { meta } = action;
  const params = _pick(action.payload, [
    "title",
    "emoji",
    "url",
    "description",
    "contactInfo",
  ]);
  const data = yield call(
    request,
    "api/admin/consulate/category",
    params,
    { method: "POST" }
  );
  Helper.toastr("Tạo danh mục thành công", "Thành công", "success");
  yield put(createConsulateSuccess(data, meta));
}

function* getConsulateDetail(action) {
  const params = _pick(action.payload, ["idCategory"]);
  const { data } = yield call(
    request,
    "api/admin/consulate/category",
    params,
    { method: "GET" }
  );
  yield put(getConsulateDetailSuccess(data));
}

function* updateActiveConsulate(action) {
  const { meta } = action;
  const isActive = _get(action, "payload.isActive");
  const params = _pick(action.payload, ["isActive", "idCategory"]);
  const result = yield call(
    request,
    "api/admin/consulate/category/update-active",
    params,
    { method: "PUT" }
  );
  yield put(updateActiveConsulateSuccess(result, meta));
  Helper.toastr(
    `${isActive ? "Kích hoạt" : "Vô hiệu hóa"} thành công`,
    "Thành công",
    "success"
  );
}

function* deleteConsulate(action) {
  const { meta } = action;
  const params = _pick(action.payload, ["idCategory"]);
  const result = yield call(
    request,
    "api/admin/consulate/category",
    params,
    { method: "DELETE" }
  );
  yield put(deleteConsulateSuccess(result, meta));
  Helper.toastr("Xóa danh mục thành công", "Thành công", "success");
}

function* updateConsulate(action) {
  const { meta } = action;
  const params = _pick(action.payload, [
    "idCategory",
    "title",
    "emoji",
    "url",
    "description",
    "contactInfo",
  ]);
  const result = yield call(
    request,
    "api/admin/consulate/category",
    params,
    { method: "PUT" }
  );
  yield put(updateConsulateSuccess(result, meta));
  Helper.toastr("Cập nhật danh mục thành công", "Thành công", "success");
}

function* updateOrderConsulate(action) {
  const { meta } = action;
  const params = _pick(action.payload, ["idCategory", "order"]);
  const result = yield call(
    request,
    "api/admin/consulate/category/update-order",
    params,
    { method: "PUT" }
  );
  yield put(updateOrderConsulateSuccess(result, meta));
  Helper.toastr("Cập nhật thứ tự thành công", "Thành công", "success");
}

function* onError() {
  yield put(stopLoading());
}

export default function* watchConsulate() {
  yield takeEvery(getAllConsulateRequest.type, safe(getAllConsulate, onError));
  yield takeLeading(
    updateActiveConsulateRequest.type,
    safe(updateActiveConsulate, onError)
  );
  yield takeLeading(
    deleteConsulateRequest.type,
    safe(deleteConsulate, onError)
  );
  yield takeLeading(
    createConsulateRequest.type,
    safe(createConsulate, onError)
  );
  yield takeLeading(
    updateConsulateRequest.type,
    safe(updateConsulate, onError)
  );
  yield takeLeading(
    updateOrderConsulateRequest.type,
    safe(updateOrderConsulate, onError)
  );
  yield takeEvery(
    getConsulateDetailRequest.type,
    safe(getConsulateDetail)
  );
}
